import moment from 'moment';

export const state = () => ({
  page: 0,
  applications: [],
  filters: '',
  resultCount: 0,
});

export const getters = {
  getData(store) {
    return store.applications;
  },
  getPage(store) {
    return store.page;
  },
  getFilters(store) {
    return store.filters;
  },
  getResultCount(store) {
    return store.resultCount;
  },
};

export const mutations = {
  reset(store) {
    store.page = 0;
    store.applications = [];
    store.filters = '';
  },
  setApplications(store, payload) {
    store.applications = payload;
  },
  clearApplications(store) {
    store.applications = [];
  },
  setPage(store, payload) {
    store.page = payload;
  },
  setFilters(store, payload) {
    store.filters = payload;
  },
  setResultCount(store, payload) {
    store.resultCount = payload;
  },
};

export const actions = {
  async reset({ commit }) {
    commit('reset');
  },
  async fetchData({ commit, state }) {
    let url = 'application?results=10&application_status=theory_completed&sort=ascending&order=updated';
    if (state.page) {
      url += `&page=${state.page}`;
    }
    if (state.filters) {
      url += state.filters;
    }

    const applications = await this.$axios.$get(url);
    const formattedDate = applications.application_list.map((application) => ({
      updated_formatted: moment(application.updated, 'YYYY-MM-DD hh:mm:ss').format('DD-MM-YYYY hh:mm:ss'),
      ...application,
    }));
    commit('setApplications', formattedDate);
    commit('setResultCount', applications.total);
  },
  async clearVehicles({ commit }) {
    commit('clearVehicles');
  },
  async setPage({ commit }, payload) {
    commit('setPage', payload);
  },
  async setFilters({ commit }, payload) {
    commit('setFilters', payload);
  },
};
